module.exports = __webpack_public_path__ + "50a208737b2ca0bfc629cda03e9ef66c.svg";